var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3245 6.04103L11.4584 3.17492V6.04103H14.3245ZM10.2084 2.29103V6.66603C10.2084 7.01121 10.4882 7.29103 10.8334 7.29103H15.4584V16.7494C15.4584 17.2591 15.0503 17.7077 14.5001 17.7077H5.41675C4.92859 17.7077 4.54175 17.3209 4.54175 16.8327V3.16603C4.54175 2.67788 4.92859 2.29103 5.41675 2.29103H10.2084ZM10.8285 1.04103H5.41675C4.23824 1.04103 3.29175 1.98752 3.29175 3.16603V16.8327C3.29175 18.0112 4.23824 18.9577 5.41675 18.9577H14.5001C15.7832 18.9577 16.7084 17.9063 16.7084 16.7494V6.66603C16.7084 6.49499 16.6383 6.33141 16.5145 6.21345L11.2651 1.21411C11.1942 1.14636 11.11 1.09767 11.0199 1.06951C10.9842 1.05836 10.9476 1.05042 10.9105 1.04581C10.8834 1.04243 10.856 1.04082 10.8285 1.04103ZM6.37508 9.8327C6.37508 9.48752 6.6549 9.2077 7.00008 9.2077H13.0834C13.4286 9.2077 13.7084 9.48752 13.7084 9.8327C13.7084 10.1779 13.4286 10.4577 13.0834 10.4577H7.00008C6.6549 10.4577 6.37508 10.1779 6.37508 9.8327ZM6.37508 12.8327C6.37508 12.4875 6.6549 12.2077 7.00008 12.2077H11.5834C11.9286 12.2077 12.2084 12.4875 12.2084 12.8327C12.2084 13.1779 11.9286 13.4577 11.5834 13.4577H7.00008C6.6549 13.4577 6.37508 13.1779 6.37508 12.8327Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders_icon.8c060393913c7e9cd36def80016115f9.svg";
export { ForwardRef as ReactComponent };